var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 历史记录 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }